export const styles = () => ({
  buttonClass: {
    height: 40,
    background: "#26BBED",
    color: "white",
    width: 82,
    padding: "8px 22px"
  },
  root: {
    display: "flex",
    background: "white",
    border: "1px solid #DADADA",
    padding: "0px 20px",
    justifyContent: "space-between",
  },
  copiedButton: {
    background: "#66D184",
    height: 40,
    color: "white",
    padding: "8px 22px",
    width: 110,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "space-between",
  },
  dialogStyle: {
    color: "red"
  },
  actions: {
    background: "white",
    display: "flex",
    padding: "24px 20px",
    justifyContent: "flex-end",
    cursor: "pointer"
  },
  viewStyle: {
    padding: 10,
    width: 460,
    wordBreak: "break-all",
  },
  body: {
    padding: "24px 20px",
    paddingBottom: 0,
    background: "white",
    maxHeight: "300px"
  },
  dottedLine: {
    border: "1px dashed #DADADA"
  },
  iconWeight: {
    fontWeight: "bold"
  },
  font: {
    fontWeight: "bold"
  },
  closeButton: {
    color: "black",
    "&:hover": {
      color: "#26bbed"
    }
  },
  bgGrey: {
    background: "#F9F9F9"
  },
  tabTitle:{
    "&:hover": {
      color: "#26bbed"
    }
  }
});